// Chapter start times: "90", "1:30", "1:02:30" (an optional fraction of a second, like "1:30.5") <-> seconds.
const TIMESTAMP = /^(?:(?:(\d+):)?(\d{1,2}):)?(\d+(?:\.\d+)?)$/

/**
 * Seconds from a timestamp typed in the chapter editor, or null when it is not one. Minutes and seconds after the
 * first part must be under 60 ("1:75" is not a timestamp; a bare "75" is 75 seconds).
 */
export const parseTimestamp = (text) => {
  const match = TIMESTAMP.exec(String(text ?? "").trim())
  if (!match) return null

  const [, hours, minutes, seconds] = match
  const hasMinutes = minutes !== undefined
  if (hasMinutes && Number(seconds) >= 60) return null
  if (hours !== undefined && Number(minutes) >= 60) return null

  return Number(hours || 0) * 3600 + Number(minutes || 0) * 60 + Number(seconds)
}

/** "m:ss" or "h:mm:ss", keeping a fraction of a second. */
export const formatTimestamp = (seconds) => {
  if (seconds === null || seconds === undefined || Number.isNaN(Number(seconds))) return ""

  const total = Number(seconds)
  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const rest = Math.round((total % 60) * 1000) / 1000
  const [whole, fraction] = String(rest).split(".")
  const secondsText = whole.padStart(2, "0") + (fraction ? `.${fraction}` : "")

  return hours ? `${hours}:${String(minutes).padStart(2, "0")}:${secondsText}` : `${minutes}:${secondsText}`
}
